import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import history from '../../../../history';


const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

class AppointmentTypeDetailsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,      
      iframeURL: '',
      isLoading: false,
      random: 0,      
    };
    
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    
  }

    appointmentFilterByDate = (formData) => {
    this.resetIframe();
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('CL_AppointmentTypeDetailsReport');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  
  renderReport() {
    return (
      <Iframe url={this.state.iframeURL}
        // width="450px"
        height="580px"
        id="myId"
        className="manual_report"
        display="initial"
        position="relative"
        onLoad={(e)=> this.onLoadReport(e)}
        key={this.state.random}
        allowFullScreen />
    );
  }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  onBackClick = () => {
    history.push('/reports/scheduling-reports');
  }

  render() {
    const { handleSubmit } = this.props;
    //   let iframeUrl = `${REPORT_URL}?%2fHC.SqlReports%2fAppointmentTypeDetailsReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.state.organizationID + '&LocationID=' + this.state.locationID;
    // let windowsHeight = window.innerHeight + 159 + "px";
    // console.log(windowsHeight);
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Scheduling {' > '} Appointment Type Details Report</h2>
        :
          <h2 className="page_title">Appointment Type Details Report</h2>
        }   
        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <div className="panel_title">
              <h7 style={styles.font}>*This report generates a list of all the appointment types/activities in the system with specific details (i.e., which roles are assigned).</h7>                    
            </div>
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">                
                <div className="col-sm-6 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.renderReport()}
      </div>
    );
  }
}

AppointmentTypeDetailsReport = reduxForm({
  form: 'AppointmentTypeDetailsReportForm',
})(AppointmentTypeDetailsReport);

function mapStateToProps(state) {
  
  return {
    orgID: state.login.loginUserInfo.organizationID,    
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {})(AppointmentTypeDetailsReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/SchedulingReports/AppointmentTypeDetailsReport.js